<template>
  <div class="slides">
    <a class="navbar-toggler" href="#" @click.prevent="menu_active = true">
      <svg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'><path stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/></svg>
    </a>
    <div class="head">
      <div class="flex-row justify-content-between align-items-center flex-grow-99999">
        <router-link to="/">
          <img class="logo" alt="Coca-Cola HBC Polska" src="../assets/coca-cola_hellenic.png">
        </router-link>
        <router-link to="/">
          <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 74.142115 216 67.71577"><path fill="#e61d2a" d="M149.3 81s-3.9 1.5-8.3 6.4c-4.5 5-7.1 10.5-5.2 12 .8.6 2.5.6 5.6-2.1a26 26 0 0 0 6.5-9.1c2-4.9 1.4-7.2 1.4-7.2m24.4 8.8c-4.9-2.5-8.5-5.6-12.3-7.5-3.6-1.9-6-2.7-8.9-2.3l-1.2.3s1.5 5.1-4.4 13.8c-6.1 8.7-11.6 8.6-13.1 6.2-1.7-2.5.4-7.7 4-12.3a41.3 41.3 0 0 1 10.1-8.7s-2-1.3-7.1 1.6a70 70 0 0 0-21.4 20.7c-7.9 11.2-9.4 17.4-10.6 22.3-1.1 4.8-.1 10 5.3 10 5.4 0 11.7-8.2 13.5-11 3.3-5.4 5.4-13.5.9-12.4-2.2.5-4 3-5.1 5.3-1.2 2.5-1.6 4.8-1.6 4.8s-1.9.6-4.4 2.5a31.6 31.6 0 0 0-4.1 3.7s0-3.9 3.1-10.2c3.1-6.3 8.8-9.2 12-9.5 2.9-.2 6.7 2.3 3.5 11.4-3.2 9.1-12.7 20.1-22.6 20.3-9.2.1-15.2-11.6-2.4-32 14.1-22.6 30.7-29.5 36-30.3 5.4-.8 7.2 1.6 7.2 1.6s4.5-2.1 10.2-1.7c6.6.5 11.7 5.1 18.4 8.4l-5 5m29.6-7.6c-4.6 3-10.9 5.6-16.9 5a91 91 0 0 0-4.9 5.4c10.5 2.1 19.7-4.4 24.6-9.9 3.1-3.5 4.6-6.6 4.6-6.6s-2.9 3.2-7.4 6.1m-14 29.6l.2-.4s-.1-.9-1-.9c-1-.1-2.3.1-5.9 4.1a52.2 52.2 0 0 0-7.6 10.7c-2.1 3.8-2.9 6.6-1.7 7.3.3.2.8.2 1.2.1.8-.2 1.7-.9 3.1-2.5l2.2-3a245 245 0 0 0 9.5-15.4m-37.2 4.3c.6-1.5 1.4-4.6-.2-5.8-1.7-1.3-6 1.7-6 4.8-.1 3.2 3 4.6 3.8 4.8.4.1.5.1.7-.3.2-.2 1.1-1.9 1.7-3.5m-3.2 5.8c-.1-.1-1.5-.7-3-1.9a7.5 7.5 0 0 1-2.2-2.7c-.1-.1-.2-.1-.2 0-.1.1-.4.3-2.7 3.7-2.3 3.4-5.8 10.4-2.6 11.6 2.1.7 5.5-2.8 7.3-5.2 1.8-2.2 3.4-5.1 3.5-5.3.1-.2 0-.2-.1-.2m36.4 8c-.9 1.4-1.9 4.1 1 2.4 3.5-2 8.5-9.6 8.5-9.6h2.2s-3 4.7-6.8 9c-3.6 3.9-7.9 7.5-11 7.2-3.5-.5-2.4-5.1-2.4-5.1s-5.1 5.4-8.6 5c-4.8-.5-3.4-6.4-3.4-6.4s-5.3 6.6-9 6.4c-5.8-.3-4.3-7.3-2.7-12.2.8-2.7 1.6-4.7 1.6-4.7l-1.8.3-1.8.1s-2.4 4.3-4.3 6.8c-1.9 2.6-10 11.3-14.8 9.6-4.5-1.7-3-8.4-.4-13.8 3.7-7.9 14.3-19.2 20.4-17.7 6.4 1.5.2 13.1.2 13.1v.1l1.3-.1c1.2-.2 2.3-.7 2.3-.7s6.3-13.3 13.4-22.1c7-8.7 21-23.7 26.5-20.1 1.4.9.8 4-1 7.7l-2.5.7a19 19 0 0 0 2.2-5.4c.9-4.5-9.7 5-17.2 15.3-7.5 10.2-12 19.4-12 19.4s1.5-.8 3.9-2.7a131 131 0 0 0 17.7-18.3c.8-.1 1.6-.1 2.3-.3a143.5 143.5 0 0 1-18 19.3c-4.5 3.8-7.9 5.9-7.9 5.9s-6.6 13.2-3 14.1c2.1.5 6.2-5.9 6.2-5.9s5.4-8.2 8.7-12c4.4-5 8.3-8 12.1-8 2.2-.1 3.6 2.3 3.6 2.3l1-1.6h6.5l-13 22m18-47.7c-4.6 3-10.9 5.6-16.9 5a91 91 0 0 0-4.9 5.4c10.5 2.1 19.7-4.4 24.6-9.9 3.1-3.5 4.6-6.6 4.6-6.6s-2.9 3.2-7.4 6.1M193.2 135h1l.8.1c.3.1.4.4.4.7 0 .3-.1.5-.3.6l-.4.1.5.3.2.5v.6h-.5v-.4c0-.4-.1-.6-.2-.7l-.6-.1h-.4v1.2h-.5zm1.7.9c0-.2 0-.4-.2-.4l-.6-.1h-.4v1h.5l.4-.1c.2-.1.3-.2.3-.4m1.9.5c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7 0-1.3-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.4.2 1.9.7.5.5.7 1.1.7 1.8m-2.6-2.2c-.6 0-1.1.2-1.5.7-.5.4-.7.9-.7 1.5 0 .7.2 1.2.7 1.6.4.5.9.7 1.5.7.7 0 1.2-.2 1.6-.7.5-.4.7-.9.7-1.6 0-.6-.2-1.1-.7-1.5-.4-.5-.9-.7-1.6-.7m-81.8-41.9h-6.1l-3.5 5.7h6.2zm-29.1 19.5c2.6-3.6 9.8-16.2 9.8-16.2s-.1-.8-.9-.9c-1 0-2.7.3-6 4.5a71.6 71.6 0 0 0-7.7 10.8c-2.1 3.8-3 6.4-1.8 7.1.3.2.8.3 1.2.2.8-.2 1.8-1 3.2-2.6l2.2-2.9m-33-17c-1.7-1.3-6 1.7-6.1 4.8 0 3.2 4 4.1 4.5 4.1 0 0 .4.1.6-.3l1.2-2.8c.6-1.5 1.4-4.6-.2-5.8m-2.6 10.9c-.1-.1-1.7-.5-3.3-1.6-1.6-1-2.3-2.5-2.4-2.6l-.2.1-2.7 3.9c-2.3 3.4-5.7 10.3-2.5 11.5 2 .8 5.5-2.8 7.4-5.2 1.7-2.2 3.7-5.6 3.8-5.8.1-.3 0-.3-.1-.3m50.3 2h2.3S89 124 82.6 123.3c-3.6-.4-2.5-4.8-2.5-4.8s-5 5.8-9.6 4.7c-4.2-1.1-1.5-8-1.5-8-.5.2-9.5 10.3-15.8 7.9-6.6-2.5-3.2-11-2-13.6l2.3-4.3-1.7.5-1.5.3s-3.2 5.1-5.1 7.6c-1.9 2.6-10.1 11.3-14.9 9.6-4.8-1.8-3.6-8.5-.9-13.8 4.4-8.7 14.8-19.3 21-17.7 6.3 1.6 1.1 11.9 1.1 11.9s1.3.1 4.3-1.9c4.3-3 10-10.9 16.2-10 2.9.4 5.6 3.4 1.9 9.1-1.2 1.8-3.1 3.4-4.7 1.8-.9-1-.1-2.8.9-4.1 1.4-1.7 3.3-1.5 3.3-1.5s1.1-2.3-1.5-2.3c-2.1.1-7.5 5-10.5 9.9-2.7 4.6-6.9 12.3-2.7 14 3.8 1.6 11.2-7.1 14.6-11.7 3.3-4.5 11.1-14.9 17.5-15.3 2.3-.1 3.6 1.9 3.6 1.9l.8-1.2h6.4l-13.1 22c-.8 1.2-1.8 3.9 1 2.3 2.8-1.5 8.5-8.9 8.5-8.9m-3.5 32.7c-4.9-3.5-10.9-5-16.3-4.8-5.5.2-8 4.3-8 4.3-2.5-4.3-7.3-6.9-14.9-6.9-12.2.2-24.4 5.8-33.9 5.8-9.3 0-16-5.8-15.8-16 .4-18 15.7-34.3 27-41.6 6.6-4.2 12.1-5.4 15.6-5 2.7.3 5.8 3.3 3.8 7.7-2.9 6.5-6.9 6-6.8 2.9.1-2 1.5-3.3 2.5-4 .6-.5 1.7-.6 2.3-.6.6-.5 1.1-4-3.6-2.9A37.5 37.5 0 0 0 30.7 91a64.8 64.8 0 0 0-15.9 29c-.9 5.5-.3 15.4 12.7 15.3 11-.1 27.2-7.3 42.1-7.2 5.8.1 10.8 1.6 14.8 4.1 3.8 2.3 8.4 5.8 10.1 8.2z"/></svg>
        </router-link>
      </div>
      <div class="flex-row align-items-center justify-items-end flex-grow">
        <div class="year">{{ year }}</div>
        <div class="tytul" v-html="$t('tytul')"/>
      </div>
    </div>
    <div class="section" :style="sectionStyle" v-html="$t($route.params.group)"/>
    <div class="content">
      <div class="side" :class="{ menu_active }">
        <div class="side_head">
          <div class="flex-row align-items-center justify-content-between">
            <router-link to="/">
              <img class="logo" alt="Coca-Cola HBC Polska" src="../assets/coca-cola_hellenic.png">
            </router-link>
            <a class="navbar-toggler" href="#" @click.prevent="menu_active = false">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="-15 0 30 30"><path d="M14 1 l -13 13 l 13 13" fill="none" stroke="rgba(0, 0, 0, 0.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </a>
          </div>
          <router-link to="/">
            <svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 74.142115 216 67.71577"><path fill="#e61d2a" d="M149.3 81s-3.9 1.5-8.3 6.4c-4.5 5-7.1 10.5-5.2 12 .8.6 2.5.6 5.6-2.1a26 26 0 0 0 6.5-9.1c2-4.9 1.4-7.2 1.4-7.2m24.4 8.8c-4.9-2.5-8.5-5.6-12.3-7.5-3.6-1.9-6-2.7-8.9-2.3l-1.2.3s1.5 5.1-4.4 13.8c-6.1 8.7-11.6 8.6-13.1 6.2-1.7-2.5.4-7.7 4-12.3a41.3 41.3 0 0 1 10.1-8.7s-2-1.3-7.1 1.6a70 70 0 0 0-21.4 20.7c-7.9 11.2-9.4 17.4-10.6 22.3-1.1 4.8-.1 10 5.3 10 5.4 0 11.7-8.2 13.5-11 3.3-5.4 5.4-13.5.9-12.4-2.2.5-4 3-5.1 5.3-1.2 2.5-1.6 4.8-1.6 4.8s-1.9.6-4.4 2.5a31.6 31.6 0 0 0-4.1 3.7s0-3.9 3.1-10.2c3.1-6.3 8.8-9.2 12-9.5 2.9-.2 6.7 2.3 3.5 11.4-3.2 9.1-12.7 20.1-22.6 20.3-9.2.1-15.2-11.6-2.4-32 14.1-22.6 30.7-29.5 36-30.3 5.4-.8 7.2 1.6 7.2 1.6s4.5-2.1 10.2-1.7c6.6.5 11.7 5.1 18.4 8.4l-5 5m29.6-7.6c-4.6 3-10.9 5.6-16.9 5a91 91 0 0 0-4.9 5.4c10.5 2.1 19.7-4.4 24.6-9.9 3.1-3.5 4.6-6.6 4.6-6.6s-2.9 3.2-7.4 6.1m-14 29.6l.2-.4s-.1-.9-1-.9c-1-.1-2.3.1-5.9 4.1a52.2 52.2 0 0 0-7.6 10.7c-2.1 3.8-2.9 6.6-1.7 7.3.3.2.8.2 1.2.1.8-.2 1.7-.9 3.1-2.5l2.2-3a245 245 0 0 0 9.5-15.4m-37.2 4.3c.6-1.5 1.4-4.6-.2-5.8-1.7-1.3-6 1.7-6 4.8-.1 3.2 3 4.6 3.8 4.8.4.1.5.1.7-.3.2-.2 1.1-1.9 1.7-3.5m-3.2 5.8c-.1-.1-1.5-.7-3-1.9a7.5 7.5 0 0 1-2.2-2.7c-.1-.1-.2-.1-.2 0-.1.1-.4.3-2.7 3.7-2.3 3.4-5.8 10.4-2.6 11.6 2.1.7 5.5-2.8 7.3-5.2 1.8-2.2 3.4-5.1 3.5-5.3.1-.2 0-.2-.1-.2m36.4 8c-.9 1.4-1.9 4.1 1 2.4 3.5-2 8.5-9.6 8.5-9.6h2.2s-3 4.7-6.8 9c-3.6 3.9-7.9 7.5-11 7.2-3.5-.5-2.4-5.1-2.4-5.1s-5.1 5.4-8.6 5c-4.8-.5-3.4-6.4-3.4-6.4s-5.3 6.6-9 6.4c-5.8-.3-4.3-7.3-2.7-12.2.8-2.7 1.6-4.7 1.6-4.7l-1.8.3-1.8.1s-2.4 4.3-4.3 6.8c-1.9 2.6-10 11.3-14.8 9.6-4.5-1.7-3-8.4-.4-13.8 3.7-7.9 14.3-19.2 20.4-17.7 6.4 1.5.2 13.1.2 13.1v.1l1.3-.1c1.2-.2 2.3-.7 2.3-.7s6.3-13.3 13.4-22.1c7-8.7 21-23.7 26.5-20.1 1.4.9.8 4-1 7.7l-2.5.7a19 19 0 0 0 2.2-5.4c.9-4.5-9.7 5-17.2 15.3-7.5 10.2-12 19.4-12 19.4s1.5-.8 3.9-2.7a131 131 0 0 0 17.7-18.3c.8-.1 1.6-.1 2.3-.3a143.5 143.5 0 0 1-18 19.3c-4.5 3.8-7.9 5.9-7.9 5.9s-6.6 13.2-3 14.1c2.1.5 6.2-5.9 6.2-5.9s5.4-8.2 8.7-12c4.4-5 8.3-8 12.1-8 2.2-.1 3.6 2.3 3.6 2.3l1-1.6h6.5l-13 22m18-47.7c-4.6 3-10.9 5.6-16.9 5a91 91 0 0 0-4.9 5.4c10.5 2.1 19.7-4.4 24.6-9.9 3.1-3.5 4.6-6.6 4.6-6.6s-2.9 3.2-7.4 6.1M193.2 135h1l.8.1c.3.1.4.4.4.7 0 .3-.1.5-.3.6l-.4.1.5.3.2.5v.6h-.5v-.4c0-.4-.1-.6-.2-.7l-.6-.1h-.4v1.2h-.5zm1.7.9c0-.2 0-.4-.2-.4l-.6-.1h-.4v1h.5l.4-.1c.2-.1.3-.2.3-.4m1.9.5c0 .8-.2 1.4-.7 1.9-.5.5-1.1.7-1.9.7-.7 0-1.3-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9 0-.7.2-1.3.7-1.8.5-.5 1.1-.7 1.8-.7.8 0 1.4.2 1.9.7.5.5.7 1.1.7 1.8m-2.6-2.2c-.6 0-1.1.2-1.5.7-.5.4-.7.9-.7 1.5 0 .7.2 1.2.7 1.6.4.5.9.7 1.5.7.7 0 1.2-.2 1.6-.7.5-.4.7-.9.7-1.6 0-.6-.2-1.1-.7-1.5-.4-.5-.9-.7-1.6-.7m-81.8-41.9h-6.1l-3.5 5.7h6.2zm-29.1 19.5c2.6-3.6 9.8-16.2 9.8-16.2s-.1-.8-.9-.9c-1 0-2.7.3-6 4.5a71.6 71.6 0 0 0-7.7 10.8c-2.1 3.8-3 6.4-1.8 7.1.3.2.8.3 1.2.2.8-.2 1.8-1 3.2-2.6l2.2-2.9m-33-17c-1.7-1.3-6 1.7-6.1 4.8 0 3.2 4 4.1 4.5 4.1 0 0 .4.1.6-.3l1.2-2.8c.6-1.5 1.4-4.6-.2-5.8m-2.6 10.9c-.1-.1-1.7-.5-3.3-1.6-1.6-1-2.3-2.5-2.4-2.6l-.2.1-2.7 3.9c-2.3 3.4-5.7 10.3-2.5 11.5 2 .8 5.5-2.8 7.4-5.2 1.7-2.2 3.7-5.6 3.8-5.8.1-.3 0-.3-.1-.3m50.3 2h2.3S89 124 82.6 123.3c-3.6-.4-2.5-4.8-2.5-4.8s-5 5.8-9.6 4.7c-4.2-1.1-1.5-8-1.5-8-.5.2-9.5 10.3-15.8 7.9-6.6-2.5-3.2-11-2-13.6l2.3-4.3-1.7.5-1.5.3s-3.2 5.1-5.1 7.6c-1.9 2.6-10.1 11.3-14.9 9.6-4.8-1.8-3.6-8.5-.9-13.8 4.4-8.7 14.8-19.3 21-17.7 6.3 1.6 1.1 11.9 1.1 11.9s1.3.1 4.3-1.9c4.3-3 10-10.9 16.2-10 2.9.4 5.6 3.4 1.9 9.1-1.2 1.8-3.1 3.4-4.7 1.8-.9-1-.1-2.8.9-4.1 1.4-1.7 3.3-1.5 3.3-1.5s1.1-2.3-1.5-2.3c-2.1.1-7.5 5-10.5 9.9-2.7 4.6-6.9 12.3-2.7 14 3.8 1.6 11.2-7.1 14.6-11.7 3.3-4.5 11.1-14.9 17.5-15.3 2.3-.1 3.6 1.9 3.6 1.9l.8-1.2h6.4l-13.1 22c-.8 1.2-1.8 3.9 1 2.3 2.8-1.5 8.5-8.9 8.5-8.9m-3.5 32.7c-4.9-3.5-10.9-5-16.3-4.8-5.5.2-8 4.3-8 4.3-2.5-4.3-7.3-6.9-14.9-6.9-12.2.2-24.4 5.8-33.9 5.8-9.3 0-16-5.8-15.8-16 .4-18 15.7-34.3 27-41.6 6.6-4.2 12.1-5.4 15.6-5 2.7.3 5.8 3.3 3.8 7.7-2.9 6.5-6.9 6-6.8 2.9.1-2 1.5-3.3 2.5-4 .6-.5 1.7-.6 2.3-.6.6-.5 1.1-4-3.6-2.9A37.5 37.5 0 0 0 30.7 91a64.8 64.8 0 0 0-15.9 29c-.9 5.5-.3 15.4 12.7 15.3 11-.1 27.2-7.3 42.1-7.2 5.8.1 10.8 1.6 14.8 4.1 3.8 2.3 8.4 5.8 10.1 8.2z"/></svg>
          </router-link>
          <div class="flex-row flex-wrap align-items-center">
            <div class="year">{{ year }}</div>
            <div class="tytul" v-html="$t('tytul')"/>
          </div>
        </div>
        <ul class="menu">
          <li
            v-for="(section, name) in sections"
            :key="name"
          >
            <router-link
              :to="{
                name: section.layout || 'slides',
                params: Object.assign(
                  {},
                  {
                    group: section.slug[$route.params.locale]
                  },
                  section.props || {}
                )
              }"
              @click.native="menu_active = false"
            >
              <span
                class="icon"
                :style="{
                  backgroundColor: section.background,
                  backgroundSize: `${section.imageSize}`,
                  backgroundImage: `url(${section.image})`
                }"
              />
              <span
                class="text"
                :style="{
                  backgroundColor: section.background
                }"
                v-html="$t(name)"
              />
            </router-link>
          </li>
        </ul>
      </div>
      <div class="slide">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    menu_active: false
  }),
  computed: {
    ...mapGetters([
      'baseUrl',
      'year',
      'sections'
    ]),
    sectionStyle () {
      return {
        backgroundColor: Object.values(this.sections).find(s => s.slug[this.$route.params.locale] === this.$route.params.group).background
      }
    }
  },
  watch: {
    menu_active (value) {
      document.body.style.overflowX = value ? 'hidden' : 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
$mobile-breakpoint: 960px;

.slides {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .head {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-right: 4rem;
    div:nth-child(1) {
      .navbar-toggler {
        @media (min-width: 321px) {
          display: none;
        }
      }
    }
    div:nth-child(2) {
      .navbar-toggler {
        @media (max-width: 320px) {
          display: none;
        }
      }
    }
    .logo {
      margin: 0.7rem 1rem;
      width: 11rem;
    }
    .year {
      margin: 0.7rem 1rem 0.7rem 3rem;
      line-height: 3rem;
      font-size: 3rem;
    }
    .tytul {
      margin: 0.7rem 1rem;
      font-size: 0.8rem;
    }
    @media (min-width: $mobile-breakpoint + 1) {
      display: none;
    }
  }
  .section {
    color: white;
    padding: 0.6rem 1rem;
    @media (min-width: $mobile-breakpoint + 1) {
      display: none;
    }
  }
  .content {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-items: stretch;
    flex-grow: 1;
  }
}
.side {
  background-color: #fdf0f1;
  box-shadow: 1px 1px 1vw #aaa;
  z-index: 1;
  padding: 0.7rem 0;
  .side_head {
    padding: 0 1rem;
  }
  position: absolute;
  left: 0;
  transition: 0.3s ease-in-out margin;
  top: 0;
  width: 100%;
  min-height: 100vh;
  margin-left: -120%;
  flex-shrink: 0;
  &.menu_active {
    margin-left: 0;
  }
  .menu {
    list-style: none;
    padding: 0;
    margin: 1.6rem 0 1rem;
    li {
      overflow: visible;
      line-height: 1.1;
      margin-bottom: 0.3rem;
      width: 100%;
      @media (min-width: $mobile-breakpoint + 1) {
        width: 21rem;
      }
      a {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-decoration: none;
        color: white;
        font-size: 81%;
      }
      .icon {
        display: block;
        width: 2rem;
        height: 2.2rem;
        padding: 0 1.4rem;
        margin-right: 0.3rem;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1.6rem 1.6rem;
      }
      .text {
        display: flex;
        height: 2.2rem;
        align-items: center;
        padding: 0 0.6rem;
        width: 15.6rem;
        transition: 0.1s ease-in-out width;
        flex-grow: 1;
        @media (min-width: $mobile-breakpoint + 1) {
          flex-grow: 0;
        }
      }
      &:hover .text, a.router-link-active .text {
        width: 18.7rem;
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%22-10%20-10%2050.141%2042.908%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M0%2022.908V0l25.141%2011.454z%22%2F%3E%3C%2Fsvg%3E");
        background-size: 2rem 2rem;
        background-repeat: no-repeat;
        background-position: right center;
      }
    }
  }
  .logo {
    width: 13rem;
    max-width: 100%;
    margin-bottom: 1rem;
  }
  .year {
    margin-left: 3rem;
    text-align: left;
    font-size: 3.6rem;
  }
  .tytul {
    color: #787a7d;
    font-size: 1rem;
    margin-left: 3rem;
    text-align: left;
  }
  @media (min-width: $mobile-breakpoint + 1) {
    padding: 2rem 0 0;
    .side_head {
      padding: 0 3rem;
    }
    position: relative;
    margin-left: 0;
    width: 18em;
  }
}
.year {
  color: #e41e2b;
  font-weight: bold;
}
.tytul {
  color: #787a7d;
}
.slide {
  position: relative;
  flex-grow: 1;
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-items: stretch;
}
.navbar-toggler {
  position: absolute;
  right: 0;
  top: 0.5rem;
  width: 2rem;
  height: 2rem;
  margin: 0.7rem 1rem;
  @media screen and (min-width: $mobile-breakpoint + 1) {
    display: none;
  }
}
</style>
